import MSlice from "../../helper/MSlice";

const commentSlice = new MSlice({ name: "comment" });

export const commentActions = commentSlice.getActions();

export default commentSlice.getReducer();
